import DataTable from "@shared/ui/data-table/DataTable";
import { Skeleton } from "@mui/material";
import { useTheme } from "@emotion/react";
import { StyledItems } from "./items.styled";
import { useItemOptions } from "./items.data";
import { useItemStructures } from "./useItemStructures";
import { useItemsBrowse } from "./useItemsBrowse";
import { useItemsNavigation } from "./useItemsNavigation";

function Items() {
  const theme = useTheme();
  const { tableStructure } = useItemStructures();
  const browse = useItemsBrowse();
  const navigation = useItemsNavigation();
  const itemOptions = useItemOptions();

  const skeletonSx = { bgcolor: theme.colors.section_color };

  return (
    <StyledItems>
      {tableStructure ? (
        <DataTable
          structure={tableStructure}
          searchForm={browse.itemSearchForm}
          onResetSearch={browse.reset}
          sortKey={browse.sortKey}
          setStructure={navigation.editBrowseStructure}
          setSortKey={browse.handleSortKeyChanged}
          sortMethod={browse.sortMethod}
          setSortMethod={browse.handleSortMethodChanged}
          data={browse.data}
          isLoading={browse.isLoading}
          options={itemOptions}
          selectRow={navigation.selectRow}
          onSelectRow={navigation.rowChosen}
          pagination={{
            page: browse.page,
            perPage: browse.perPage,
            hasNextPage: browse.hasNextPage,
            hasPrevPage: browse.hasPrevPage,
            onNextPage: browse.handleNextPage,
            onPrevPage: browse.handlePrevPage,
            onRowsPerPageChange: browse.handleRowsPerPageChange,
          }}
        />
      ) : (
        <Skeleton variant="rectangular" height={150} animation="wave" sx={skeletonSx} />
      )}
    </StyledItems>
  );
}

export default Items;
